import React, { useState } from 'react';
import { C } from '../constants';

export default function StarRating({ value, onChange, readonly = false, size = 18 }) {
  const [hov, setHov] = useState(0);
  return (
    <div style={{ display:'flex', gap:'3px', alignItems:'center' }}>
      {[1,2,3,4,5].map(i => (
        <span key={i}
          onClick={() => !readonly && onChange && onChange(i)}
          onMouseEnter={() => !readonly && setHov(i)}
          onMouseLeave={() => !readonly && setHov(0)}
          style={{ fontSize:`${size}px`, cursor:readonly ? 'default' : 'pointer', color: i <= (hov || value) ? C.gold : C.textDim, transition:'color 0.15s', lineHeight:1, userSelect:'none' }}>★</span>
      ))}
    </div>
  );
}
